module.exports = __webpack_public_path__ + "fonts/font.e459ff2.woff2";